// Get elements by class name
const productsOnPage = document.querySelector(".products-onpage")
const loadMoreBtn = document.querySelector(".load-more-btn")
const loadMoreSpinner = document.querySelector(".load-more-spinner")
const productGrid = document.getElementById("product-grid")
const customShowProduct = document.querySelector(".custom-show-product")
const customTotalProduct = document.querySelector(".custom-total-product")
const loadMoreProgressBar = document.querySelector(".load-more-progress-bar")
const swatchesImageChange = document.querySelectorAll(
  ".custom-product-swatches input",
)

// Initialize variables

let nextUrl = productsOnPage ? productsOnPage.dataset.nextUrl : null

// Function to load more products
const loadMoreProducts = () => {
  if (!nextUrl) return

  // Show spinner, hide load more button
  loadMoreBtn.style.display = "none"
  loadMoreSpinner.classList.remove("hidden")

  // Make AJAX request
  fetch(nextUrl)
    .then((response) => response.text())
    .then((data) => {
      // Hide spinner
      loadMoreSpinner.classList.add("hidden")

      // Create a temporary div to parse the HTML string
      const tempDiv = document.createElement("div")
      tempDiv.innerHTML = data

      // Find new products
      const newProducts = tempDiv.querySelector(".products-onpage")
      if (!newProducts) return

      nextUrl = newProducts.dataset.nextUrl

      // Show load more button if there's more to load
      if (nextUrl) {
        loadMoreBtn.style.display = "inline-flex"
      }

      // Append new products to the existing ones
      productsOnPage.innerHTML += newProducts.innerHTML

      // Recount total products
      countTotalProduct()

      updateVisibility()
    })
    .catch((error) => {
      console.error("Error:", error)
      // Hide spinner and show load more button in case of error
      loadMoreSpinner.style.display = "none"
      loadMoreBtn.style.display = "inline-flex"
    })
}

// Function to count total products
const countTotalProduct = () => {
  const resultCount = productGrid
    ? productGrid.querySelectorAll("li").length
    : 0
  if (customShowProduct) {
    customShowProduct.textContent = resultCount
  }
  const totalResultsElem = customTotalProduct
  const totalResults = totalResultsElem
    ? parseInt(totalResultsElem.textContent, 10)
    : 0
  const finalWidth = totalResults ? (resultCount * 100) / totalResults : 0

  // Ensure finalWidth doesn't exceed 100%
  const progressBar = loadMoreProgressBar
  if (progressBar) {
    progressBar.style.width = `${Math.min(finalWidth, 100)}%`
  }
}
// Initial count
countTotalProduct()

// Function to swatch image change
const swatchesImageChanges = (event) => {
  if (event.target.matches(".custom-product-swatches input")) {
    const imageSrc = event.target.getAttribute("variant_image")
    const cardInner = event.target.closest(".card-wrapper")
    if (cardInner) {
      const mainImage = cardInner.querySelector(".card__media img")
      if (mainImage) {
        mainImage.src = imageSrc
        mainImage.srcset = imageSrc
      }
    }
  }
}

// Event listener for load more button
if (loadMoreBtn) {
  loadMoreBtn.addEventListener("click", loadMoreProducts)
}

// Event listener for swatch image change
document.addEventListener("click", swatchesImageChanges)
document.addEventListener("change", swatchesImageChanges)
